import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    constructor(){}

    IsNumber(value: any){
        return !isNaN(this.ToInteger(value));
    }

    ToInteger(value: any): number{
        //return parseInt('${value}', 10);
        return parseInt(`${value}`, 10);
    }

    PadNumber(value: number){
        if(this.IsNumber(value)){
            //return '0${value}'.slice(2);
            return `0${value}`.slice(-2);
        }
        else {
            return '';
        }
    }
    PadLeft(text : string, padChar : string, size : number): string {
        return (String(padChar).repeat(size) + text).substr( (size * -1), size) ;
    }
}